import React, { FunctionComponent } from "react";
import { Table } from "evergreen-ui";
import { AbstractTableHeaderCellRenderer } from "./AbstractTableHeaderCellRenderer";

export class TableReadOnlyHeaderCellRenderer<T> extends AbstractTableHeaderCellRenderer<T> {
    protected getMemoizedComponent(): FunctionComponent {
        const {columnConfig: {displayName, textAlign}} = this.input;
        const textProps = textAlign ? { style: { textAlign } } : undefined;
        return React.memo(() => (
            <Table.TextHeaderCell className={"jc-header-cell"} textProps={textProps}>
                {displayName}
            </Table.TextHeaderCell>
        ));
    }
}
